export default "__VITE_ASSET__BL7FUlCr__"